import { TABLE_FILTER_CONSTANTS } from "constants/employee.constants";
import { EMPLOYEE_LIST_ACTIONS } from "Store/actions/employeeListActions";

const initialState = {
    employeesData:{
        employees: [],
        pagination:{
            currentPage: 1,
            totalPages: 1,
            pageSize: 10,
            totalRecords: 0
        },
        complete: TABLE_FILTER_CONSTANTS.ALL,
        loading: false
    },
    updateEmployeeLoader: false,
    toast: {
        show: false,
        message: ""
    },
    managerEmployeesListData: [],
    HRBPEmpIDListData: [],
    requisitionViewData: []
}

const employeeListReducer = (state=initialState,action) => {
    switch (action.type) {
        case EMPLOYEE_LIST_ACTIONS.SET_EMPLOYEE:
            return{
                ...state,
                employeesData: {
                    ...state.employeesData,
                    employees: action.payload.data,
                    pagination: action.payload.pagination,
                    loading: false,
                }
            }
        case EMPLOYEE_LIST_ACTIONS.FETCH_EMPLOYEES_LOADER:
            return{
                ...state,
                employeesData:{
                    ...state.employeesData,
                    loading: action.payload
                }
            }
        case EMPLOYEE_LIST_ACTIONS.UPDATE_EMPLOYEE_LOADER:            
            return{
                ...state,
                updateEmployeeLoader: action.payload
            }
        case EMPLOYEE_LIST_ACTIONS.TOAST_MESSAGE:            
            return{
                ...state,
                toast: {
                    show: action.payload.show,
                    message: action.payload.message
                }
            }

        case EMPLOYEE_LIST_ACTIONS.CLEAR_EMPLOYEES:
            return {
                ...initialState
            };
    
        case EMPLOYEE_LIST_ACTIONS.SET_MANAGER_EMPLOYEES_LIST:
            return {
                ...state,
                managerEmployeesListData: action.payload
            };
        
        case EMPLOYEE_LIST_ACTIONS.SET_HRBP_EMP_ID_LIST:
            return {
                ...state,
                HRBPEmpIDListData: action.payload
            };
        
        case EMPLOYEE_LIST_ACTIONS.SET_REQUISITION_VIEW:
            return {
                ...state,
                requisitionViewData: action.payload
            };
        
        case EMPLOYEE_LIST_ACTIONS.SET_COMPLETE_EMPLOYEES:
            return {
                ...state,
                employeesData: {
                    ...state.employeesData,
                    complete: action.payload
                }
            };
    
        case EMPLOYEE_LIST_ACTIONS.CLEAR_EMPLOYEES_DRAWER_DATA:
            return {
                ...state,
                managerEmployeesListData: [],
                HRBPEmpIDListData: [],
                requisitionViewData: []
            }
        default:
            return state
    }
}

export default employeeListReducer